import { computed } from 'vue'
import { getAudienceConfig } from '@/utils/config.js'

export function useAudienceConfig(props = {}) {
    return computed(() => {
        // Priority order:
        // 1. Global config set by plugin installation
        // 2. Fallback to getAudienceConfig()
        const globalConfig = window.AUDIENCE_CONFIG
        const baseConfig = globalConfig || getAudienceConfig()
        
        console.log("🌍 Using global AUDIENCE_CONFIG:", !!globalConfig)
        console.log("⚙️ Base config:", baseConfig)
        
        const finalConfig = {
            apiBaseUrl: props.apiBaseUrl || baseConfig.apiBaseUrl,
            authToken: props.authToken || baseConfig.authToken,
            pusher: {
                ...baseConfig.pusher,
                ...props.pusherConfig
            }
        }
        
        console.log("🔧 Final audience config:", finalConfig)
        return finalConfig
    })
}
